<template>
  <div class="ticket-list-item">
    <slot/>
  </div>
</template>

<script>
  export default {
    name: 'TicketListItem'
  }
</script>
